// extracted by mini-css-extract-plugin
export default {"tableWrap":"RightList_tableWrap__D0-C1","simplePagingWrap":"RightList_simplePagingWrap__YTr8i"};